import { IonButton, IonCol, IonContent, IonIcon, IonPage, IonRow, IonText, IonInput, IonSpinner } from "@ionic/react"
import Foot from "../../Footer"
import Select from "react-select"
import Head from "../../Header"
import Sidebar from "../../Sidebar"
import DataTable from "react-data-table-component";
import { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router";
import service from "../../../Service/service";
import swal from 'sweetalert';
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { searchOutline, chevronDownOutline } from "ionicons/icons";
import "../../../theme/style2.css"

const LeaveBalanceReport: React.FC = () => {
    const history = useHistory();
    const [Id] = useState(localStorage.getItem("SignupEmpId"));
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        if (Id === null) {
            history.push("/login");
        } else {
        }
    }, [Id, history]);

    const [data, setData] = useState([]);

    data.forEach((item: any, index: any) => { item.serial = index + 1; });

    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    const [Id1, setId1] = useState("");
    const [sts, setSts] = useState();

    const [modalopen, setModalopen] = useState(false);
    const [modalOp, setModalOp] = useState(false);

    const [business, setBusiness] = useState("");
    const [department, setDeapartment] = useState("");
    const [businessUnitArr, setBusinessUnitArr] = useState([]);
    const [departmentUnitArr, setDepartmentUnitArr] = useState([]);
    const [createdBy]: any = useState(localStorage.getItem("SignupEmpId"));

    const [loading, setloading] = useState(false)

    //------------Businessunit Autocomplete-------------------//

    const optionss = [
        { value: 'true', label: 'Active' },
        { value: 'false', label: 'Inactive' },
    ]

    const [selectedOption, setSelectedOption] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [menuIsOpen, setMenuIsOpen] = useState(false);

    const [status, setstatus] = useState(optionss[0].value);

    const handleStateChange = (selectedOption: any) => {
        setSelectedOption(selectedOption);
    };

    const handleInputChange = (inputValue: any) => {
        setInputValue(inputValue);
    };

    const handleMenuOpen = () => {
        setMenuIsOpen(true);
    };

    const handleMenuClose = () => {
        setMenuIsOpen(false);
    };

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };
    const Placeholder = () => {
        if (inputValue === '' && !selectedOption && !isFocused) {
            return <span style={{ color: "black" }}>Select Business Unit</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };

    const options = [

        ...businessUnitArr.map((state: any) => ({
            value: state.id,
            label: state.businessUnitName,
        })),
        { value: '', label: 'All' },
    ];
    const handleBusinessUnitChange = (selectedOption: any) => {
        console.log(selectedOption.value, "kn");
        setBusiness(selectedOption.value);
        ViewAllDepartmentunit(selectedOption.value);
    };

    //--------------Departmentunit Autocomplete--------------------//

    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [departmentInputValue, setDepartmentInputValue] = useState('');
    const [departmentIsFocused, setDepartmentIsFocused] = useState(false);
    const [departmentMenuIsOpen, setDepartmentMenuIsOpen] = useState(false);

    const handleDepartmentChange = (selectedOption: any) => {
        setSelectedDepartment(selectedOption);
    };

    const handleDepartmentInputChange = (inputValue: any) => {
        setDepartmentInputValue(inputValue);
    };

    const handleDepartmentMenuOpen = () => {
        setDepartmentMenuIsOpen(true);
    };

    const handleDepartmentMenuClose = () => {
        setDepartmentMenuIsOpen(false);
    };

    const handleDepartmentFocus = () => {
        setDepartmentIsFocused(true);
    };

    const handleDepartmentBlur = () => {
        setDepartmentIsFocused(false);
    };

    const DepartmentPlaceholder = () => {
        if (
            departmentInputValue === '' &&
            !selectedDepartment &&
            !departmentIsFocused
        ) {
            return <span style={{ color: "black" }}>Select Department Unit</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };
    const DepartmentDropdownIndicator: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);
        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const departmentOptions = [
        ...departmentUnitArr.map((state: any) => ({
            value: state.id,
            label: state.departmentName,

        })),
        { value: '', label: 'All' },
    ];
    const handleDepartmentUnitChange = (selectedOption: any) => {
        setDeapartment(selectedOption.value);
    };
    const back = () => {
        history.goBack();
    }
    //-----------------------Status Autocomplete--------------------//

    const [selectedOption1, setSelectedOption1] = useState(null);
    const [inputValue1, setInputValue1] = useState('');
    const [isFocused1, setIsFocused1] = useState(false);
    const [menuIsOpen1, setMenuIsOpen1] = useState(false);

    const handleStateChange1 = (selectedOption1: any) => {
        setSelectedOption1(selectedOption1);
    };

    const handleInputChange1 = (inputValue1: any) => {
        setInputValue1(inputValue1);
    };

    const handleMenuOpen1 = () => {
        setMenuIsOpen1(true);
    };

    const handleMenuClose1 = () => {
        setMenuIsOpen1(false);
    };

    const handleFocus1 = () => {
        setIsFocused1(true);
    };

    const handleBlur1 = () => {
        setIsFocused1(false);
    };
    const Placeholders = () => {
        if (inputValue1 === '' && !selectedOption1 && !isFocused1) {
            return <span style={{ color: "black" }}>Select Status</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicators: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };

    const handlestatusChange = (selectedOption1: any) => {
        setstatus(selectedOption1.value)
    }

    //----------------GetAll Employeelist APi---------------//

    useEffect(() => {
        ViewAllBusinessunit();
    }, []);

    //-------------------Dropdown BusinessUnit Api-------------------//

    const ViewAllBusinessunit = () => {
        service.GetAllBusinessUnitDropDown()
            .then((response) => {
                console.log("Bussiness Unit")
                console.log(response);
                if (response.data.Status === "200") {
                    setBusinessUnitArr(response.data.Data)
                    //ViewAllDepartmentunit1()
                }
                else {
                    setBusinessUnitArr([])
                }
            })
    }

    //-----------------Dropdown Departmentunit Api-------------------//

    const ViewAllDepartmentunit = (id: any) => {
        setDeapartment("");
        service.GetAllDepartmentUnitDropDown(id)
            .then((response) => {
                console.log("Department Unit")
                console.log(response);
                if (response.data.Status === "200") {
                    setDepartmentUnitArr(response.data.Data)
                } else {
                    setDepartmentUnitArr([])
                }
            })
    }

    const Downloadpdf = () => {
        setloading(true)
        service.EmployeeLeavePdf(business, department, status)
            .then((response) => {
                if (response.status === '200') {
                    setloading(false)
                    console.log('PDF generated and downloaded successfully.');
                } else {
                    setloading(false)
                    sweetAlert("", 'No Data Found', 'error' || 'No DATA FOUND!');
                }
            })
            .catch((error) => {
                setloading(false)
                swal('An unexpected error occurred: ' + error.message);
            });
    };

    const DownloadExcel = () => {
        setloading(true)
        service.EmployeeLeaveExcel(business, department, status)
            .then((response) => {
                if (response.status === '200') {
                    setloading(false)
                    console.log('Excel generated and downloaded successfully.');
                } else {
                    setloading(false)
                    sweetAlert("", 'No Data Found', 'error' || 'No DATA FOUND!');
                }
            })
            .catch((error) => {
                setloading(false)
                swal('An unexpected error occurred: ' + error.message);
            });
    };

    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col">
                                <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                    <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />Employees Leave Balance Report</h3>
                            </div>
                        </div>
                    </div>
                    <div>
                        <form className="row addmore">
                            <div className="form-group col-md-4">
                                <label style={{ fontWeight: "bold" }}>
                                    Business Unit
                                </label>
                                <div>
                                    <Select
                                        options={options}
                                        value={options.find((option) => option.value === business) || null}
                                        onChange={handleBusinessUnitChange}
                                        onInputChange={handleInputChange}
                                        onMenuOpen={handleMenuOpen}
                                        onMenuClose={handleMenuClose}
                                        onFocus={handleFocus}
                                        onBlur={handleBlur}
                                        menuIsOpen={menuIsOpen}
                                        isSearchable
                                        placeholder={<Placeholder />}
                                        components={{
                                            DropdownIndicator: DropdownIndicator,
                                        }}
                                        className="custom-select2"
                                    />
                                </div>

                            </div>
                            <div className="form-group col-md-4">
                                <label style={{ fontWeight: "bold" }}>Department Unit</label>
                                <div>
                                    <Select
                                        options={departmentOptions}
                                        value={departmentOptions.find((option) => option.value === department) || null}
                                        onChange={handleDepartmentUnitChange}
                                        onInputChange={handleDepartmentInputChange}
                                        onMenuOpen={handleDepartmentMenuOpen}
                                        onMenuClose={handleDepartmentMenuClose}
                                        onFocus={handleDepartmentFocus}
                                        onBlur={handleDepartmentBlur}
                                        menuIsOpen={departmentMenuIsOpen}
                                        isSearchable
                                        placeholder={<DepartmentPlaceholder />}
                                        components={{
                                            DropdownIndicator: DepartmentDropdownIndicator,
                                        }}
                                        className="custom-select"
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label style={{ fontWeight: 'bold' }}>Employee Status</label>
                                    <div>
                                        <Select
                                            options={optionss}
                                            value={optionss.find((option: any) => option.value === status) || null}
                                            onChange={handlestatusChange}
                                            onInputChange={handleInputChange1}
                                            onMenuOpen={handleMenuOpen1}
                                            onMenuClose={handleMenuClose1}
                                            onFocus={handleFocus1}
                                            onBlur={handleBlur1}
                                            menuIsOpen={menuIsOpen1}
                                            isSearchable
                                            placeholder={<Placeholders />}
                                            components={{
                                                DropdownIndicator: DropdownIndicators,
                                            }}
                                            className="custom-select3"
                                        />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div style={{ marginTop: "5px", display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                        <div className="col-sm-6 col-md-3">
                            <button
                                className={`btn btn-success btn-block w-100`}
                                onClick={DownloadExcel}
                            >
                                Download Excel
                            </button>
                        </div>
                        <div className="col-sm-6 col-md-3">
                            <button
                                className={`btn btn-success btn-block w-100`}
                                onClick={Downloadpdf}
                            >
                                Download PDF
                            </button>
                        </div>
                    </div>
                </div>
                {loading && (
                    <div
                        style={{
                            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                        }}
                    >
                        <div >
                            <IonSpinner style={{
                                width: "40px",
                                height: "40px",
                                color: "#ff8a53"
                            }} name="lines" />
                        </div>
                    </div>
                )}
            </IonContent>
        </IonPage>
    )
}

export default LeaveBalanceReport